import { Component, inject, signal } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faHandshake,
  faChartLine,
  faCoins,
  faUsers,
  faUser,
  faGear,
  faCircleQuestion,
  faRightFromBracket,
  faFileContract,
  faIdCard,
  faBars,
  faXmark,
  faBox,
  faSitemap,
} from '@fortawesome/pro-solid-svg-icons';
import { Auth } from '../../core/auth/auth';
import { ContractStatusService } from '../../core/services/contract-status.service';
import { PopupConfirmService } from '../../shared/services/popup-confirm.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-app-shell',
  imports: [RouterOutlet, RouterLink, RouterLinkActive, CommonModule, FontAwesomeModule],
  templateUrl: './app-shell.html',
  styleUrl: './app-shell.scss',
})
export class AppShell {
  private readonly auth = inject(Auth);
  private readonly router = inject(Router);
  private readonly popupConfirmService = inject(PopupConfirmService);
  readonly contractStatusService = inject(ContractStatusService);

  // Sidebar toggle
  sidebarOpen = signal(false);
  sidebarCollapsed = signal(false);

  readonly appVersion = environment.version;

  // Icons
  faHandshake = faHandshake;
  faChartLine = faChartLine;
  faCoins = faCoins;
  faUsers = faUsers;
  faUser = faUser;
  faGear = faGear;
  faFileContract = faFileContract;
  faIdCard = faIdCard;
  faCircleQuestion = faCircleQuestion;
  faRightFromBracket = faRightFromBracket;
  faBars = faBars;
  faXmark = faXmark;
  faBox = faBox;
  faSitemap = faSitemap;

  get currentUser() {
    return this.auth.currentUser || null;
  }

  get isAdmin() {
    return this.currentUser?.roles.includes('admin');
  }

  toggleSidebar(): void {
    this.sidebarOpen.update((open) => !open);
  }

  closeSidebar(): void {
    this.sidebarOpen.set(false);
  }

  toggleSidebarCollapse(): void {
    this.sidebarCollapsed.update((collapsed) => !collapsed);
  }

  logout(): void {
    this.popupConfirmService.showLogoutConfirm(() => {
      this.auth.logout().subscribe({
        next: () => {
          void this.router.navigateByUrl('/login');
        },
        error: () => {
          void this.router.navigateByUrl('/login');
        },
      });
    });
  }
}
